<template>
	<div>
		<div class="form-group" v-for="opt in filter.inputs.mode.options" :key="opt.value">
			<label class="form-label label-auto">
				<input type="radio" name="mode" v-model="mode" :value="opt.value" />
				{{ opt.label }}
			</label>
		</div>
		<div class="form-group form-group-32">
			<div class="form-input span_12" v-if="mode != 'without' && mode != 'with'">
				<autocomplete type="tag" 
					:params="{type : this.filter.inputs.value.params.linkedtype}" 
					:prepopulate="value" 
					:name="filter.name" 
					:minChars="1"
					@updated="updateAutocomplete" />
			</div>
		</div>
	</div>
</template>

<script>
    import ListingFilterMixin from './ListingFilterMixin.js';
    import Autocomplete from 'vcomponents/utilities/Autocomplete.vue'

	export default{
		mixins		: [
			ListingFilterMixin
		],

		data(){	
			return {
				mode	: '',
				value	: [], 
			}
		},

		computed	: {
			data(){
				return {
					mode	: this.mode,
					value	: this.value,
				}
			}
		},
		
		methods : {
			updateAutocomplete(value){
				this.value = [];
				
				for (var i in value){
					this.value.push(value[i]);
				}
			}
        },
        components: {
            Autocomplete
        }
	}
</script>
